import $ from 'jquery';
import { register_view_type } from '../lib/view_manager.js';
import * as filter_manager from '../lib/filter_manager.js';

register_view_type(
	['list', 'long-list'],
	{
		init( $view, args ) {
			let $container = $view.find('.js-gendernaut-list');
			let $load_more = $view.find('.js-gendernaut-load-more');
			let page_size = $container.find('.js-gendernaut-item').length;
			let type = $view.data('type');

			let instance = this;

			instance.$container = $container;
			instance.$load_more = $load_more;
			instance.page_size = page_size;
			instance.total_items = Infinity;
			instance.next_page_size = false;
			instance.$available = $();
			instance.last_loaded = false;
			instance.loading = false;

			$container.gndr_isotope({
				itemSelector: '.js-gendernaut-item',
				layoutMode: 'vertical',
			});
			$container.gndr_imagesLoaded().progress( function() {
				$container.gndr_isotope('layout');
			});
			$container.gndr_infiniteScroll({
				path: function(){
					let offset = this.loadCount * 100 + page_size;
					if ( offset < instance.total_items ) {
						return `${args.rest_url}gendernaut/v1/paging/${args.query}/${type}/${offset}/100`;
					}
					return false;
				},
				responseBody: 'json',
				history: false,
				scrollThreshold: false,
			});

			$container.on( 'load.infiniteScroll', function( event, data ) {
				let $new_items = $(data.content).find('.js-gendernaut-item');
				instance.$available = instance.$available.add( $new_items );
				instance.total_items = data.total_items;
				instance.last_loaded = data.is_last_page;
				instance.loading = false;
			});

			$load_more.click(function(){
				instance.add_items();
			});
		},
		display( $view ) {
			this.$container.gndr_isotope('layout');
		},
		filter( $view, filters ) {
			let $container = this.$container;
			let instance = this;

			$container.gndr_isotope( {
				filter: function() {
					return filter_manager.item_apply_filters( $(this), filters );
				}
			} );

			let num_visible = $container.gndr_isotope('getFilteredItemElements').length;
			if (num_visible < instance.page_size) {
				instance.add_items();
			}
		},
		add_items() {
			let $container = this.$container;
			let instance = this;

			instance.$load_more.attr('disabled', 'disabled');

			if ( instance.$available.length ) {
				let page_size = instance.page_size;

				let num_visible = $container.gndr_isotope('getFilteredItemElements').length;

				if ( ! instance.next_page_size ) {
					instance.next_page_size = num_visible + page_size - (num_visible % page_size);
				}

				let $items = instance.$available.slice(0, page_size);
				instance.$available = instance.$available.slice(page_size);

				$container.gndr_infiniteScroll('appendItems', $items);
				$container.gndr_isotope('appended', $items);

				num_visible = $container.gndr_isotope('getFilteredItemElements').length;
				if (num_visible < instance.next_page_size) {
					instance.add_items();
				}
				else {
					instance.next_page_size = false;
					instance.$load_more.attr('disabled', false);

					if ( instance.$available.length < page_size && ! instance.last_loaded ) {
						instance.loading = $container.gndr_infiniteScroll('loadNextPage');
					}
				}
			}
			else if ( instance.loading ) {
				instance.loading.then( instance.add_items.bind(instance) );
			}
			else if ( ! instance.last_loaded ) {
				$container.gndr_infiniteScroll('loadNextPage').then( instance.add_items.bind(instance) );
			}
			else {
				instance.$load_more.hide();
			}
		}
	}
);
